import { BasketOfferModel } from '../model/basket-offer.model';

export class AddItemToBasketAction {
  static type = '[BASKET] Add item';

  constructor(readonly product: BasketOfferModel, readonly count: number) {}
}
